"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service for updating the widget.
 */
class Updater {
    /**
     * Updater constructor
     *
     * @param {WidgetUpdaterPluginManager} widgetUpdaterPluginManager
     */
    constructor(widgetUpdaterPluginManager) {
        this.widgetUpdaterPluginManager = widgetUpdaterPluginManager;
    }
    /**
     * Calls update method of all definitions having the corresponding updateType
     *
     * @param {string} type
     * @param value
     * @param {WidgetConfig} widgetConfig
     * @param {WidgetState} widgetState
     * @param {EventContainerContext} eventContext
     * @returns {Promise<*>}
     */
    update(type, value, widgetConfig, widgetState, eventContext) {
        const updaterDefinitions = this.widgetUpdaterPluginManager
            .getDefinitions()
            .filter((definition) => definition.getUpdateType() === type)
            .sort((definitionX, definitionY) => definitionX.getPriority() - definitionY.getPriority());
        return Promise.all(this.doUpdate(updaterDefinitions, value, widgetConfig, widgetState, eventContext)).then((updated) => {
            return updated;
        });
    }
    /**
     * Does the iterative promise handling of updater plugins.
     *
     * @param {WidgetUpdaterPluginDefinition[]} definitions
     * @param value
     * @param {WidgetConfig} widgetConfig
     * @param {WidgetState} widgetState
     * @param {EventContainerContext} eventContext
     * @returns {Promise<*>[]}
     */
    doUpdate(definitions, value, widgetConfig, widgetState, eventContext) {
        if (!definitions.length) {
            return [Promise.resolve(false)];
        }
        let promises = [];
        definitions.forEach((definition) => {
            promises.push(this.widgetUpdaterPluginManager
                .create(definition.getId())
                .update(value, widgetConfig, widgetState, eventContext));
        });
        return promises;
    }
}
exports.default = Updater;
